import React from 'react';

export interface CartIngressConfig {
    fetchCms: () => void;
    isCartApiReady: boolean;
}

export const useCartIngress = ({ fetchCms, isCartApiReady }: CartIngressConfig) => {
    const [isInitialApisCalled, setIsInitialApisCalled] = React.useState(false);

    React.useEffect(() => {
        if (isCartApiReady && !isInitialApisCalled) {
            setIsInitialApisCalled(true);
            fetchCms();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCartApiReady]);

    return null;
};
